module.exports = __webpack_public_path__ + "static/media/ValU.1742f86c.png";